const regionSettings = require('@/' + process.env.VUE_APP_REGION + '.yml')
import { ORDER_TYPES } from 'nandos-middleware-api/model/food-basket'
import FoodBasketItem from 'nandos-middleware-api/model/food-basket-item'
import GiftCardBasketItem from 'nandos-middleware-api/model/gift-card-basket-item'
import UserProduct from 'nandos-middleware-api/model/user-product'

const CURRENCY = regionSettings.currency

export default class InsiderAnalyticsTracker {

  constructor() {
    this._getApi()
  }

  _getApi() {
    var scriptElement = document.createElement('script')
    var params = [
      `id=${process.env.VUE_APP_INSIDER_TRACKING_ID}`,
    ]
    scriptElement.src = `//${process.env.VUE_APP_INSIDER_TRACKING_API}?${params.join('&')}`
    scriptElement.setAttribute('async', '')

    document.body.appendChild(scriptElement)
  }

  setUser(user) {
    let data = {
      uuid: user.id,
      birthday: user.birthday,
      name: user.name,
      surname: user.lastName,
      email: user.email,
      phone_number: user.mobilePhoneNumber,
      language: user.preferredLanguage,
      gdpr_optin: null, // Insider have requested that this be hard-coded to null
      email_optin: user.marketingOptIn,
      sms_optin: user.marketingOptIn,
      whatsapp_optin: user.marketingOptIn,
      custom: {
        loyaltyNumber: user.loyaltyNumber
      },
    }

    _track('user', data)
  }

  productImpressions(productImpressions) {
  }

  productView(product) {
  }

  checkout(step, basket) {
  }

  paymentOption(paymentSource, paymentAmount, isMultiPartPayment) {
  }

  purchase(transactionId, basket, affiliation) {
    window.insider_object = {
      page: { type: 'confirmation' }, 
      transaction: { order_id: transactionId }, 
    }
  }

  search(path, query) {
  }

  pageView(path) {
  }
}

function _getOrderTypeFromBasket(basket) {
  switch(basket.orderType) {
    case ORDER_TYPES.DELIVERY: return 'delivery'
    case ORDER_TYPES.COLLECTION: return basket.kerbsideCollect ? 'kerbside' : 'collection'
    case ORDER_TYPES.EAT_IN: return 'eatIn'
  }
}

function _toMoney(val) {
  return parseFloat(val / 100)
}

function getTrackingDataFromItem(item) {
  if(item instanceof UserProduct) {
    return _getTrackingDataFromProduct(item)
  }
  else if(item instanceof FoodBasketItem) {
    return _getTrackingDataFromFoodBasketItem(item)
  }
  else if(item instanceof GiftCardBasketItem) {
    return _getTrackingDataFromGiftCard(item)
  }
  else {
    return item
  }
}

function _getTrackingDataFromProduct(product) {
  return {
    id: product.getId(),
    name: product.getName(),
    currency: CURRENCY,
    unit_price: _toMoney(product.computePrice()),
    taxonomy: product.trackingCategory ? [product.trackingCategory] : null,
    custom: {
      variant: product.getConfigurationDescription()
    },
    url: '',
    product_image_url: '',
  }
}

function _getTrackingDataFromFoodBasketItem(item) {
  return {
    product: {
      id: item.id,
      name: item.productName,
      currency: CURRENCY,
      unit_price: _toMoney(item.productPrice),
      custom: {
        variant: item.computedDescription
      },
      url: '',
      product_image_url: '',
    },
    quantity: item.quantity,
    subtotal: _toMoney(item.productPrice * item.quantity),
  }
}

function _getTrackingDataFromGiftCard(item) {
  return {
    product: {
      id: 'nandos-gift-card',
      name: 'Gift Card',
      currency: CURRENCY,
      unit_price: _toMoney(item.price),
      custom: {
        variant: `${_toMoney(item.price)}, design: ${item.srcImageUrl}`,
      },
      url: '',
      product_image_url: '',
    },
    quantity: item.cards.length,
    subtotal: _toMoney(item.price * item.cards.length),
  }
}

function _track(eventName, data = {}) {
  window.insider_object = {
    [eventName]: data 
  }

  // try { spApi.reInitOnChange() }
  // catch(e) { }
}